import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");
import TranslationService from "ceres/app/services/TranslationService";
import { serializeForm, getLabel } from "ceres/app/helper/serializeForm";

import Vue from "vue";
import { Swiper } from 'swiper';
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser && browser.name)
    {
        $("html").addClass(browser.name);
    }
    else
    {
        $("html").addClass("unkown-os");
    }

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {

        if(window.innerWidth < 1200){
            const buttons = document.querySelectorAll('li.ddown');

            Array.from(buttons).forEach(function(element)
            {
                element.addEventListener('click', (event) => {
                    if(!event.target.closest(".ddown-inner")){
                        let elm;
                        if(event.target.classList.contains("ddown")){
                            elm = event.target;
                        }else{
                            elm = event.target.closest(".ddown");
                        }
                        if(elm.classList.contains("clicked")) {
                            elm.classList.remove("clicked");
                        }else{
                            const activeElm = document.querySelector('li.ddown.clicked');
                            if(activeElm){
                                activeElm.classList.remove("clicked");
                            }
                            elm.classList.add("clicked");
                        }
                    }
                });
            });
            document.querySelector("body").addEventListener('click', (event) => {
                if(!event.target.closest(".ddown")){
                    const activeElm = document.querySelector('li.ddown.clicked');
                    if(activeElm){
                        activeElm.classList.remove("clicked");
                    }
                }
            });
        }


        // bootstrap toggle collapse fix language-select found on stackoverflow
        document.querySelector("body").click()

        if(!!window.navigator.userAgent.match(/MSIE|Trident/)){
            $("#ie-info-modal").modal("show");
        }

        const offset = 250;
        var offsetSingle = 635;
        const duration = 300;

        vueApp.$store.commit("setViewPortSize", window.innerWidth);

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
            // Weitere Commits bei Resize:
            vueApp.$store.commit("setViewPortSize", window.innerWidth);
        });

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        let scrollWasTriggered = false;
        window.addEventListener("scroll", function()
        {
            if(!!document.querySelector(".page-singleitem")){
                if (window.scrollY > 1000 && !document.querySelector(".scroll-to-basket").classList.contains("scroll-to-basket--show")){
                    document.querySelector(".scroll-to-basket").classList.add("scroll-to-basket--show")
                }
                else if(window.scrollY <= 1000 && document.querySelector(".scroll-to-basket").classList.contains("scroll-to-basket--show")){
                        document.querySelector(".scroll-to-basket").classList.remove("scroll-to-basket--show")
                }
            }



            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }

                if ($('.single').length) {



                    // if ($(this).scrollTop() > offsetSingle) {
                    //     $('.single__footer-row').fadeIn(150);
                    //     // calc height / width of image
                    //     if($('.single__footer-row--name-img').height() > 150){
                    //         $('.single__footer-row--name-img img').css({'height': '100px', 'width': 'unset'});
                    //     }
                    // } else {
                    //     $('.single__footer-row').fadeOut(150);
                    // }

                }
            }

            if(!scrollWasTriggered){
                scrollWasTriggered = true;

                if(sessionStorage.getItem("banner") != null && sessionStorage.getItem("banner") == "false"){
                    $(".header__banner").remove();
                }else{
                    $(".header__banner").addClass("is-visible");
                    $('#page-body').css("paddingTop", parseFloat($('#page-body').css("paddingTop")) + $(".header__banner").height() + 20 + "px");
                }
            }

        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        $(".js-mobile-navigation__close").click(function () {
            $("body").removeClass("menu-is-visible");
            $(".mobile-navigation").removeClass("open");
        });

        $(".js-service-box__toggle").on("click", function () {

            if ($(this).hasClass("service-box__open")) {
                $(this).removeClass("service-box__open");
                $(".service-box").css("right", "-265px");
                $(this).find(".fa").addClass("fa-chevron-down");
                $(this).find(".fa").removeClass("fa-chevron-up");
            } else {
                $(this).addClass("service-box__open");
                $(".service-box").css("right", "0px");
                $(this).find(".fa").removeClass("fa-chevron-down");
                $(this).find(".fa").addClass("fa-chevron-up");
            }

        });

        if ($(".homepage-swiper").length) {

            let hasHoverImgs = false;

            $('.homepage-swiper__container').each(function(index, item){
                if($(item).find(".homepage-swiper__img-hover-src-mobile").length){
                    hasHoverImgs = true;
                    let srcToCheckMobile = $(item).find(".homepage-swiper__img-hover-src-mobile")[0].dataset.srcset;
                    let srcToCheckDesktop = $(item).find(".homepage-swiper__img-hover-src-desktop")[0].dataset.srcset;

                    let srcFallbackMobile = $(item).find(".homepage-swiper__img-src-mobile")[0].dataset.srcset;
                    let srcFallbackDesktop = $(item).find(".homepage-swiper__img-src-desktop")[0].dataset.srcset;

                    $.get( window.location.origin + srcToCheckMobile)
                        .done(() => {
                            // vorhanden

                            $.get( window.location.origin + srcToCheckDesktop)
                                .done(() => {
                                    // vorhanden
                                }).fail((data, data2, data3) => {
                                $(item).find(".homepage-swiper__img-hover-src-desktop")[0].dataset.srcset = srcFallbackDesktop;
                                $(item).find(".homepage-swiper__img-hover-src-desktop").attr("srcset", srcFallbackDesktop);

                                initHomeSwiper();
                            });

                        }).fail((data, data2, data3) => {
                        $(item).find(".homepage-swiper__img-hover-src-mobile")[0].dataset.srcset = srcFallbackMobile;
                        $(item).find(".homepage-swiper__img-hover-src-mobile").attr("srcset", srcFallbackMobile);

                        $.get( window.location.origin + srcToCheckDesktop)
                            .done(() => {
                                // vorhanden
                            }).fail((data, data2, data3) => {
                            $(item).find(".homepage-swiper__img-hover-src-desktop")[0].dataset.srcset = srcFallbackDesktop;
                            $(item).find(".homepage-swiper__img-hover-src-desktop").attr("srcset", srcFallbackDesktop);

                            initHomeSwiper();
                        });
                    });
                }

            });

            var initHomeSwiper = function(){
                var swipe1 = new Swiper(".homepage-swiper", {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    spaceBetween: 30,
                    // Disable preloading of all images
                    preloadImages: false,
                    // Enable lazy loading
                    lazy: true,
                    loop: false,
                    slidesPerView: 1,
                    centeredSlides: true,
                    pagination: {
                        el: ".swiper-pagination"
                    },
                    breakpointsInverse: true,
                    breakpoints: {
                        991: {
                            allowTouchMove: false
                        }
                    },
                    on: {
                        slideChange: function (swiper) {
                            let index = parseInt(swipe1.activeIndex)+1;
                            if(hasHoverImgs){
                                if(window.innerWidth < 576 && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-src-mobile") && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img--hover")){
                                    document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] img")
                                        .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-src-mobile").dataset.srcset);
                                    document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img--hover")
                                        .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-hover-src-mobile").dataset.srcset)
                                }else{
                                    if(!!document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-src-desktop") && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img--hover")){
                                        document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] img")
                                            .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-src-desktop").dataset.srcset);
                                        document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img--hover")
                                            .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='"+index+"'] .homepage-swiper__img-hover-src-desktop").dataset.srcset)
                                    }
                                }
                            }
                        },
                        init: function(swiper){
                            if(hasHoverImgs){
                                if(window.innerWidth < 576 && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-src-mobile") && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img--hover")){
                                    document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] img")
                                        .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-src-mobile").dataset.srcset);
                                    document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img--hover")
                                        .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-hover-src-mobile").dataset.srcset)
                                }else{
                                    if(!!document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-src-desktop") && !!document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img--hover")){
                                        document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] img")
                                            .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-src-desktop").dataset.srcset);
                                        document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img--hover")
                                            .setAttribute("src", document.querySelector(".homepage-swiper .swiper-slide[data-index='1'] .homepage-swiper__img-hover-src-desktop").dataset.srcset)
                                    }
                                }
                            }
                        }
                    },
                });
            };

            if(hasHoverImgs){
                setInterval(function(){
                    if(!!document.querySelector(".homepage-swiper .swiper-slide-active .homepage-swiper__img--hover")){
                        document.querySelector(".homepage-swiper .swiper-slide-active .homepage-swiper__img--hover").classList.toggle("opacity-1");
                    }
                }, 5000);
                initHomeSwiper();
            }else{
                initHomeSwiper();
            }


        }

        if($('.category-header__img-src-mobile').length){
            let hasHoverImgs = false;
            if($(".category-header__img-hover-src-mobile").length){
                hasHoverImgs = true;
                let srcToCheckMobile = $(".category-header__img-hover-src-mobile").attr("srcset");
                let srcToCheckDesktop = $(".category-header__img-hover-src-desktop").attr("srcset");

                let srcFallbackMobile = $(".category-header__img-src-mobile").attr("srcset");
                let srcFallbackDesktop = $(".category-header__img-src-desktop").attr("srcset");

                $.get( window.location.origin + srcToCheckMobile)
                    .done(() => {
                        // vorhanden
                    }).fail((data, data2, data3) => {
                    $(".category-header__img-hover-src-mobile").attr("srcset", srcFallbackMobile);
                });

                $.get( window.location.origin + srcToCheckDesktop)
                    .done(() => {
                        // vorhanden
                    }).fail((data, data2, data3) => {
                    $(".category-header__img-hover-src-desktop").attr("srcset", srcFallbackDesktop);
                });

                if(hasHoverImgs){
                    setInterval(function(){
                        document.querySelector(".category-header__image--hover").classList.toggle("opacity-1");
                    }, 5000);
                }
            }
        }

        if ($(".category-swiper").length) {

            var initCatSwiper = function(){
                var swipe2 = new Swiper(".category-swiper", {
                    navigation: {
                        nextEl: '.category-swiper-next',
                        prevEl: '.category-swiper-prev',
                    },
                    spaceBetween: 30,
                    loop: false,
                    centeredSlides: true,
                    breakpointsInverse: true,
                    breakpoints: {
                        991: {
                            allowTouchMove: false
                        }
                    },
                    on: {
                        slideChange: function () {
                            let index = parseInt(swipe2.activeIndex)+1;
                            if(hasHoverImgs){
                                if(window.innerWidth < 992 && !!document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-src-mobile") && !!document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img--hover")){
                                    document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] img")
                                        .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-src-mobile").dataset.srcset);
                                    document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img--hover")
                                        .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-hover-src-mobile").dataset.srcset)
                                }else{
                                    if(!!document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-hover-src-desktop") && !!document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img--hover")){
                                        document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] img")
                                            .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-src-desktop").dataset.srcset);
                                        document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img--hover")
                                            .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='"+index+"'] .category-swiper__img-hover-src-desktop").dataset.srcset)
                                    }
                                }
                            }
                        },
                        init: function(){
                            if(hasHoverImgs){
                                if(window.innerWidth < 992 && typeof document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-src-mobile").dataset !== "undefined" && !!document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img--hover")){
                                    document.querySelector(".category-swiper .swiper-slide[data-index='1'] img")
                                        .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-src-mobile").dataset.srcset);
                                    document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img--hover")
                                        .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-hover-src-mobile").dataset.srcset)
                                }else{
                                    if(typeof document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-src-desktop").dataset !== "undefined" && !!document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img--hover")){
                                        document.querySelector(".category-swiper .swiper-slide[data-index='1'] img")
                                            .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-src-desktop").dataset.srcset);
                                        document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img--hover")
                                            .setAttribute("src", document.querySelector(".category-swiper .swiper-slide[data-index='1'] .category-swiper__img-hover-src-desktop").dataset.srcset)
                                    }
                                }
                            }
                        }
                    },
                });
            };

            let hasHoverImgs = false;
            $('.category-swiper__container').each(function(index, item){
                if($(item).find(".category-swiper__img-hover-src-mobile").length){
                    hasHoverImgs = true;
                    let srcToCheckMobile = $(item).find(".category-swiper__img-hover-src-mobile").attr("data-srcset");
                    let srcToCheckDesktop = $(item).find(".category-swiper__img-hover-src-desktop").attr("data-srcset");

                    let srcFallbackMobile = $(item).find(".category-swiper__img-src-mobile").attr("data-srcset");
                    let srcFallbackDesktop = $(item).find(".category-swiper__img-src-desktop").attr("data-srcset");

                    let useFbMobile = false;
                    let useFbDesktop = false;

                    $.get( window.location.origin + srcToCheckMobile)
                        .done(() => {
                            // vorhanden

                            $.get( window.location.origin + srcToCheckDesktop)
                                .done(() => {
                                    // vorhanden
                                }).fail((data, data2, data3) => {
                                useFbDesktop = true;
                                $(item).find(".category-swiper__img-hover-src-desktop").attr("data-srcset", srcFallbackDesktop);

                                initCatSwiper();
                            });

                        }).fail((data, data2, data3) => {
                        useFbMobile = true;
                        $(item).find(".category-swiper__img-hover-src-mobile").attr("data-srcset", srcFallbackMobile);

                        $.get( window.location.origin + srcToCheckDesktop)
                            .done(() => {
                                // vorhanden
                            }).fail((data, data2, data3) => {
                            useFbDesktop = true;
                            $(item).find(".category-swiper__img-hover-src-desktop").attr("data-srcset", srcFallbackDesktop);

                            initCatSwiper();
                        });

                    });

                    if(hasHoverImgs){
                        setInterval(function(){
                            if(useFbMobile && window.innerWidth < 992){
                                $(item).find(".category-swiper__img--hover")[0]
                                    .setAttribute("src", srcFallbackMobile)
                            }
                            if(useFbDesktop && window.innerWidth > 991){
                                $(item).find(".category-swiper__img--hover")[0]
                                    .setAttribute("src", srcFallbackDesktop)
                            }
                            if(!!document.querySelector(".category-swiper .swiper-slide-active .category-swiper__img--hover")){
                                document.querySelector(".category-swiper .swiper-slide-active .category-swiper__img--hover").classList.toggle("opacity-1");
                            }
                        }, 5000);
                        initCatSwiper();
                    }else{
                        initCatSwiper();
                    }
                }
            });

            if(!hasHoverImgs){
                initCatSwiper();
            }
        }

        $(document).on("mouseover", "[data-toggle=tooltip]:not(.disabled)", function()
        {
            const vueApp = document.getElementById("vue-app");
            const mt = parseInt(vueApp.style.marginTop);

            setTimeout(function()
            {
                if ($(".tooltip").length)
                {
                    const styleArr = $(".tooltip").attr("style").split(" ");

                    let topKey = 0;
                    for (const key in styleArr)
                    {
                        if (styleArr[key] == "top:")
                        {
                            topKey = parseInt(key) + 1;
                        }
                    }
                    styleArr[topKey] = "-" + mt + "px;";
                    const styleString = styleArr.join(" ");

                    $(".tooltip").attr("style", styleString);
                }
            }, 1);
        });

        if($('.single-rightside').length){
            $('[data-toggle="popover"]').each(function () {
                let $this = $(this);
                $this.popover({
                    trigger: 'hover',
                    container: $this
                })
            });
        }else{
            $(function () {
                $('[data-toggle="popover"]').popover()
            });
        }

        window.setTimeout(() => {
            if ($(".sidebar-categories").length) {
                $("#page-body").addClass("category-" + $(".sidebar-categories").find("ul > li.active").attr("data-category-id"));
                //$(".js-category__bubble").addClass("category__bubble--" + $(".sidebar-categories").find("ul > li.active").attr("data-category-id"));
                $(".category__frosch").addClass("category__frosch--id-" + $(".sidebar-categories").find("ul > li.active").attr("data-category-id"));
            } else if ($("#single__parent-cat-id").length) {
                $("#page-body").addClass("category-" + $("#single__parent-cat-id").text());
                //$(".js-category__bubble").addClass("category__bubble--" + $("#single__parent-cat-id").text());
                $(".category__frosch").addClass("category__frosch--id-" + $("#single__parent-cat-id").text());
            } else if($('.js-category__bubble').length && $('.js-category__bubble').attr('class').indexOf('category__bubble--') > -1){
                var num = $('.js-category__bubble').attr('class').match(/\d+/)[0];
                $("#page-body").addClass("category-"+num);
            }else {
                $("#page-body").addClass("category-0");
            }
        }, 1);

        var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        var lastScrollTop = 0;

        $(window).scroll(function (event) {

            var st = $(this).scrollTop();

            if (width > 991) {


                if(st > 100){
                    if(!$(".js-header").hasClass("scroll-header")){
                        $(".js-header").addClass("scroll-header");
                    }
                }
                else{
                    if($(".js-header").hasClass("scroll-header")){
                        $(".js-header").removeClass("scroll-header");
                    }
                }




                if (st < 139) {
                    if ($(".js-header").hasClass("header--hidden") || $(".js-header").hasClass("header-scroll-to-top")) {
                        $(".js-header").addClass("header--vis");
                    }


                    $(".js-header").removeClass("header--hidden");
                    // $(".js-header").removeClass("header-scroll-to-top");

                    // let the animation for --vis finish and remove the class
                    /*setTimeout(function(){
                        $(".js-header").removeClass("header--vis");
                    }, 400);*/
                }
                // scroll down
                else if (st > lastScrollTop) {
                    // $(".js-header").addClass("header-scroll-to-top"); // header-hidden
                    $(".js-header").removeClass("header--vis");
                }
                // scroll up
                else {
                    $(".js-header").removeClass("header--hidden");
                    // $(".js-header").addClass("header-scroll-to-top");
                    $(".js-header").removeClass("header--vis");
                }
            }else if(width < 586){
                if (st < 139) {
                    $(".order-xs-3").removeClass("hide-search-mobile");
                }
                // scroll down
                else if (st > lastScrollTop) {
                    $('.order-xs-3').addClass('hide-search-mobile');
                }
                // scroll up
                else {
                    $(".order-xs-3").removeClass("hide-search-mobile");
                }
            }

            lastScrollTop = st;
        });

        // <editor-fold desc="Vue Cat Funktion überschreiben -> nur twig basiert"
        $(".sidebar-categories").on("click", "a.nav-link", function (ev) {
            ev.preventDefault();
            window.location.href = $(this).attr("href");
        });

        $(".mainmenu").on("click", "li a", function (ev) {
            ev.preventDefault();
            window.location.href = $(this).attr("href");
        });

        $(".category-breadcrumb__list-item a").click(function (ev) {
            ev.preventDefault();
            window.location.href = $(this).attr("href");
        });
        // </editor-fold>
        /*
                    $('.mainmenu .ddown').on('mouseenter', function () {

                        var el = $(this).find('ul.collapse');
                        el.css('visibility', 'visible');
                        el.find('li').hide();

                        $(this).find('ul.collapse').stop().animate({
                            height: "550px",
                            visibility: "visible",
                            opacity: 1
                        }, 300, function () {
                            // Animation complete.
                            el.find('li').show();
                        });
                    }).on('mouseleave', function () {

                        var el = $(this).find('ul.collapse');
                        el.find('li').hide();

                        $(this).find('ul.collapse').stop().animate({
                            height: "0px"
                        }, 300, function () {
                            // Animation complete.
                            el.css('visibility', 'hidden');
                        });
                    });
        */

        $("body").on("click", ".open-service-versand", function () {

            // scroll to desc container
            var element = document.getElementsByClassName("single__description")[0];

            element.scrollIntoView();

            $(".single__description .nav-item a[href=\"#service-versand\"]").trigger("click");

        });

        // mobil click handler single desc contents
        $(document).on("click", ".nav-link--inner", function (ev) {
            ev.preventDefault();

            var target = $(this).attr("href");
            let isVisible = $(target).hasClass("pane-is-visible");

            $(".nav-link--inner").removeClass("show active");
            $(".tab-pane").hide().addClass("pane-is-hidden").removeClass("pane-is-visible");

            if(!isVisible){
                $(target).show().addClass("pane-is-visible").removeClass("pane-is-hidden");
            }

        });

        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        // INFO für ratgeber
        $('#ratgeber-open-contact-modal').click(function(ev){
            ev.preventDefault();

            $('#kontakt').modal('show');
        });
        $('.kontakt-send').click(function(e){

            e.preventDefault();

            $('.has-error').removeClass('has-error');

            var allFilled = true;
            $.each($('#kontakt-modal-wrapper input[required], #kontakt-modal-wrapper textarea[required]'), function(index, item){
                if($(item).attr('id') == 'kontakt-datenschutz'){
                    if($(item).prop('checked') == false){
                        allFilled = false;
                        return false;
                    }
                }else if ($(item).val() == ''){
                    allFilled = false;
                    return false;
                }
            });

            if(!allFilled){

                $.each($('#kontakt-modal-wrapper input[required], #kontakt-modal-wrapper textarea[required]'), function(index, item){
                    if($(item).attr('id') == 'kontakt-datenschutz'){
                        if($(item).prop('checked') == false){
                            $(item).closest('.form-group').addClass('has-error');
                        }
                    }else if($(item).val() == ''){
                        $(item).closest('.form-group').addClass('has-error');
                    }
                });

            }else{

                if(!validateEmail($('[name="kontakt-mail"]').val())){
                    $('[kontakt-mail="email"]').closest('div').addClass('has-error');
                    NotificationService.error(
                        "Bitte überprüfen Sie Ihre E-Mail Adresse!"
                    );
                }else {

                    const mailObj =
                        {
                            name: $('[name="kontakt-name"]').val(),
                            userMail: $('[name="kontakt-mail"]').val(),
                            subject: $('[name="kontakt-subject"]').val(),
                            itemId: $('[name="kontakt-item"]').val(),
                            message: $('[name="kontakt-text"]').val(),
                            type: 'contact',
                        };

                    const formData = serializeForm($('#kontakt-modal-wrapper .modal-body')[0]);

                    $.ajax({
                        url: 'https://www.froschkoenig24.de/rest/fk24/customer/contact/mail',
                        type: 'POST',
                        async: true,
                        data: {
                            data: formData,
                            template: "Ceres::Customer.Components.Contact.ContactMail",
                            type: 'contact'
                        },
                        success: function (data, textStatus, jqXHR) {
                            // success
                            //console.log(data);
                            //location.reload();

                            let trans = TranslationService.translate("Ceres::Template.contactSendSuccess");

                            NotificationService.success(
                                trans
                            );
                        },
                        error: function (data) {
                            //console.log(data);
                        }
                    });
                }
            }

        });



        $('.header__user-login').click(function(){$('.header--vis').removeClass('header--vis')});

        $('.item-contact__trigger-form').click(function(e){
            e.preventDefault();

            $('.nav-link:not(.nav-link--inner)[href="#contact"]').trigger('click');
            $(window).scrollTop($('.nav-link[href="#contact"]').offset().top);
        });

        if($(".cross-selling-swiper").length) {
            var crossSwiper = new Swiper(".cross-selling-swiper", {
                spaceBetween: 10,
                slidesPerView: 4,
                loop: false,
                navigation: {
                    nextEl: '.cross-selling-swiper__button-next',
                    prevEl: '.cross-selling-swiper__button-prev',
                },
                allowTouchMove: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    586: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    991: {
                        allowTouchMove: false
                    }
                }
            });
            window.dispatchEvent(new Event('resize'));

            crossSwiper.on('slideChange', function () {
                window.dispatchEvent(new Event('resize'));
            });
        }

        $('.item-bottom__item--share').click(function(){
            $('.share-dd').toggleClass('share-dd--show');
        });

        $('body').on('click', '.swiper-button-next', function(){
            window.dispatchEvent(new Event('resize'));
        });

        $('.js--single-description__more').click(function(ev){
            ev.preventDefault();
            $('.single-description').toggleClass('is-open');

            if($(this).hasClass('text-more')){
                $(this).html('Weniger anzeigen&nbsp;<i class="fa fa-chevron-up"></i>');
                $(this).removeClass('text-more').addClass('text-less');
            }else{
                $(this).html('Mehr anzeigen&nbsp;<i class="fa fa-chevron-down"></i>');
                $(this).removeClass('text-less').addClass('text-more');
            }
        });

        $('.page-link').click(function(){
            window.location.href = window.location.href;
        });

        $('.list-controls-inner select').change(function(){
            window.location.href = window.location.href;
        });

        $('.single__get-offer').click(function(ev){
            ev.preventDefault();

            $('#angebot').modal('show');
        });

        /*$.each($('.megamenu-lazy'), function(index, item){
            $(item).attr('src', $(item)[0].dataset.src);
        });*/

        $('.mainmenu .ddown:not(.is-loaded)').on('mouseover', function(){
            $.each($(this).find('.megamenu-lazy'), function(index, item){
                $(item).attr('src', $(item)[0].dataset.src);
            });
            $(this).addClass('is-loaded');
        });

        window.dispatchEvent(new Event('resize'));

        if($('.single-rightside--inner').length){
            $('body').addClass('is-single');
        }


        if(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)){
            $('body').addClass('is-ios');
        }

        if (navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1) {
            $("body").addClass("is-safari");
        }

        $('#video-modal-wrapper').on('click', '.video-modal-thumb', function(){
            $('#video-modal-wrapper').find('iframe').attr('src', 'https://www.youtube.com/embed/'+$(this).attr('videoid')+'?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0')
        });

        // INFO: Videos für Landingpages
        $(".category-video").each(function(index, item){
            $('#video-modal-wrapper .modal-footer').append('<img class="video-modal-thumb" src="https://img.youtube.com/vi/'+$(item).attr('videoid')+'/1.jpg" videoid="'+$(item).attr('videoid')+'">');

            if(index === 0){
                $('#video-modal-wrapper .modal-title').text("Videos");
                $('#video-modal-wrapper').find('iframe').attr('src', 'https://www.youtube.com/embed/'+$(item).attr('videoid')+'?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0')
            }
        });

        $("body").on("click", '.single__fullscreen', function(ev){
            ev.preventDefault();

            $('.single-swiper .swiper-slide.swiper-slide-active .single-swiper__image').click();
        });

        setTimeout(function() {
            $('#checkoutButtonEasyCreditInstallment').text('Kaufen');
            $('#checkoutButtonPayPalInstallment').text('Kaufen');
        }, 2000);

        $(".header__mobile-search-toggle").on("click", function(){
            $(".mobile-search").toggleClass("mobile-search--active");
            $("body").addClass("search-open");
        });

        $('#custom__contact-send:not(.single-contact-send)').click(function(e){

            e.preventDefault();

            if($('.category').length){
                var sel = '.category';
            }else{
                var sel = '.single';
            }

            $('.has-error').removeClass('has-error');

            var allFilled = true;
            $.each($(sel+' #contact-form input[required], '+sel+' #contact-form textarea[required]'), function(index, item){
                if($(item).val() == ''){
                    allFilled = false;
                    return false;
                }
            });

            if(!allFilled){

                $.each($(sel+' #contact-form input[required], '+sel+' #contact-form textarea[required]'), function(index, item){
                    if($(item).val() == ''){
                        $(item).closest('.input-unit').addClass('has-error');
                    }
                });

            }else{

                if(!validateEmail($('[name="email"]').val())){
                    $('[name="email"]').closest('div').addClass('has-error');
                    NotificationService.error(
                        "Bitte überprüfen Sie Ihre E-Mail Adresse!"
                    );
                }else{
                    const mailObj =
                        {
                            name : $('[name="name"]').val(),
                            userMail : $('[name="email"]').val(),
                            subject : $('[name="subject"]').val(),
                            orderId : $('[name="order"]').val(),
                            message : $('[name="message"]').val(),
                            type : 'contact',
                            mailToMe : $('[name="mailToMe"]').val()
                        };

                    const formData = serializeForm($('#contact-form')[0]);

                    $.ajax({
                        url    		:   'https://www.froschkoenig24.de/rest/fk24/customer/contact/mail',
                        type   		:   'POST',
                        async   	:   true,
                        data    	:   {data: formData, template: "Ceres::Customer.Components.Contact.ContactMail", type : 'contact'},
                        success		: 	function(data, textStatus, jqXHR)
                        {
                            // success
                            //console.log(data);
                            //location.reload();

                            let trans = TranslationService.translate("Ceres::Template.contactSendSuccess");

                            NotificationService.success(
                                trans
                            );
                        },
                        error: function (data) {
                            //console.log(data);
                        }
                    });
                }

            }

        });

        $(".header__banner-close").click(function(){
            $('#page-body').css("paddingTop", parseFloat($('#page-body').css("paddingTop")) - ($(".header__banner").height() + 20) + "px");
            $(".header__banner").remove();
            sessionStorage.setItem('banner', 'false');
        });

        fixPopperZIndexes();

        $(".list-itemsperpage select").change(function(){
            vueApp.$store.dispatch('selectItemsPerPage', $(this).val())
        });

         // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }))});

        $('.list-sort select').change(function(){
            vueApp.$store.dispatch('selectItemListSorting', $(this).val())
        });

        if(window.location.href.indexOf("/faq") > -1){
            document.querySelector("body").classList.add("faq-page")
        }

        // close fl search when clicked outside of search
        if(window.innerWidth >= 768){
            document.addEventListener("click", function(evt){
                if(!evt.target.closest(".fl-as-visible") && !evt.target.closest(".header__search")){
                    if(!!document.querySelector(".fl-assisted-suggest")){
                        if(document.querySelector(".fl-assisted-suggest").style.visibility === "visible"){
                            document.querySelector(".fl-closing-btn").click()
                        }
                    }
                }
            })
        }

        $(document).on('click','.card .facet-title', function() {
            let activeElement = $(this).closest('.card-columns.row').find('.card.open');
            let clickElement  = $(this).parent();
            if(activeElement.hasClass('open') && clickElement.hasClass('open')) {
                clickElement.removeClass('open')
            }else {
                activeElement.removeClass('open')
                clickElement.toggleClass('open');
            }
        });
    });

    if(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)){
        $('body').addClass('is-ios');
    }

    document.addEventListener("DOMContentLoaded", function() {
        let lazyImages = [].slice.call(document.querySelectorAll(".lazy-img"));
        let active = false;

        const lazyLoad = function() {
            if (active === false) {
                active = true;

                setTimeout(function() {
                    lazyImages.forEach(function(lazyImage) {
                        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                            lazyImage.src = lazyImage.dataset.src;
                            if(typeof lazyImage.dataset.srcset !== "undefined" && lazyImage.dataset.srcset !== ""){
                                lazyImage.srcset = lazyImage.dataset.srcset;
                            }
                            lazyImage.classList.remove("lazy-img");

                            lazyImages = lazyImages.filter(function(image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener("scroll", lazyLoad);
                                window.removeEventListener("resize", lazyLoad);
                                window.removeEventListener("orientationchange", lazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        };

        document.addEventListener("scroll", lazyLoad);
        window.addEventListener("resize", lazyLoad);
        window.addEventListener("orientationchange", lazyLoad);
    });

    document.addEventListener("DOMContentLoaded", function() {
        var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

        if ("IntersectionObserver" in window) {
            let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.style["backgroundImage"] = entry.target.dataset.background;
                        entry.target.classList.remove("lazy-background");
                        lazyBackgroundObserver.unobserve(entry.target);
                    }
                });
            });

            lazyBackgrounds.forEach(function(lazyBackground) {
                lazyBackgroundObserver.observe(lazyBackground);
            });
        }
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
            case "info":
                NotificationService.info(event.detail.message);
                break;
            case "log":
                NotificationService.log(event.detail.message);
                break;
            case "error":
                NotificationService.error(event.detail.message);
                break;
            case "success":
                NotificationService.success(event.detail.message);
                break;
            case "warning":
                NotificationService.warn(event.detail.message);
                break;
            default:
                console.log("no type such as:" + event.detail.type);
                break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
